import LastUpdate from '../../../../../../components/LastUpdate/LastUpdate';
import { getLastHistoryEvent, createLastEventToDisplayFromHistory } from '../../../../../../utils/history';
import { ILogisticServiceHistory } from '../../../../../../types/suscription/history.types';
import { LOGISTIC_SERVICE_STATUS_NAME } from 'types/services';
import LogisticServiceStatusSelect from '../../LogisticServiceStatusSelect/LogisticServiceStatusSelect';

interface ILogisticServiceLastUpdateProps {
  statusName: LOGISTIC_SERVICE_STATUS_NAME;
  logisticServiceHistoryData: ILogisticServiceHistory[];
  isProblemActive?: boolean;
  onStatusChange?: (status: LOGISTIC_SERVICE_STATUS_NAME) => void;
  isLate?: boolean | null;
  displayStatus?: boolean;
}

export const LogisticServiceLastUpdate = ({
  displayStatus = true,
  statusName,
  logisticServiceHistoryData,
  isProblemActive,
  onStatusChange,
  isLate
}: ILogisticServiceLastUpdateProps) => {
  const lastEvent = getLastHistoryEvent<ILogisticServiceHistory>(logisticServiceHistoryData);
  const lastEventToDisplay = createLastEventToDisplayFromHistory(lastEvent, isProblemActive);

  if (!lastEventToDisplay) {
    return <LogisticServiceStatusSelect currentStatus={statusName} onStatusChange={onStatusChange} isLate={isLate} />;
  }

  return (
    <LastUpdate lastEvent={lastEventToDisplay}>
      {displayStatus ? (
        <LogisticServiceStatusSelect currentStatus={statusName} onStatusChange={onStatusChange} isLate={isLate} />
      ) : null}
    </LastUpdate>
  );
};
